const initialState = {
  data: {},
};

const tourPackageCreatePayloadReducers = (state = initialState, action) => {
  switch (action?.type) {
    case "RECEIVE_DATA_PAYLOAD":
      return {
        ...state,
        data: action.payload,
      };
    default:
      return state;
  }
};

export default tourPackageCreatePayloadReducers;
